import { create } from 'zustand';

type TraceStatus = 'idle' | 'running' | 'complete' | 'error';

interface HolisticState {
    // Trace state (persists across selection changes so Analysis Tab can show it)
    status: TraceStatus;
    chain: string | null;
    addresses: string[];
    currentStep: string;
    results: Record<string, any>;
    error: string | null;

    // Modal state — controls the confirmation dialog
    modalOpen: boolean;
    modalChain: string;
    modalAddresses: string[];

    setRunning: (chain: string, addresses: string[]) => void;
    setStep: (step: string) => void;
    mergeStepResult: (step: string, data: any) => void;
    setComplete: (results: Record<string, any>) => void;
    setError: (err: string) => void;
    reset: () => void;
    openModal: (chain: string, addresses: string[]) => void;
    closeModal: () => void;
}

export const useHolisticStore = create<HolisticState>((set) => ({
    status: 'idle',
    chain: null,
    addresses: [],
    currentStep: '',
    results: {},
    error: null,

    modalOpen: false,
    modalChain: 'ETH',
    modalAddresses: [],

    setRunning: (chain, addresses) => set({
        status: 'running', chain, addresses,
        currentStep: 'Initializing...', results: {}, error: null,
    }),
    setStep: (step) => set({ currentStep: step }),
    mergeStepResult: (step, data) => set((s) => ({ results: { ...s.results, [step]: data } })),
    setComplete: (results) => set({ status: 'complete', results, currentStep: '' }),
    setError: (err) => set({ status: 'error', error: err, currentStep: '' }),
    reset: () => set({ status: 'idle', chain: null, addresses: [], currentStep: '', results: {}, error: null }),

    openModal: (chain, addresses) => set({ modalOpen: true, modalChain: chain, modalAddresses: addresses }),
    closeModal: () => set({ modalOpen: false }),
}));
